export default {
    imageDashboardTransaction: {
        action: 'Acción',
        transactionId: 'Transaction Id',
        variationCount: 'Recuento de variantes',
        date: 'Fecha',
        description: 'Description',
        selectedImage: 'Selected Image',
        goTo: 'Ir a',
    },
};
